<template>
  <QBtn class="extra-btn-square" :class="[inverted ? 'extra-btn-square-inverted' : '', $attrs.class]" text-color="accent" no-caps v-bind="$attrs">
    <span v-if="displayBadge" class="extra-btn-square-badge" :class="[badgeColor ? `bg-${badgeColor}` : null]" />
    <QChip v-if="displayChip" class="chip" :label="t('CORE.@NEW')" color="secondary" text-color="white" size="sm" />
  </QBtn>
</template>

<script setup>
  import { useI18n } from "vue-i18n";

  const { t } = useI18n();

  defineProps({
    inverted: {
      type: Boolean,
      default: false,
    },
    badgeColor: {
      type: String,
      default: "",
    },
    displayChip: {
      type: Boolean,
      default: false,
    },
    displayBadge: {
      type: Boolean,
      default: false,
    },
  });
</script>

<style lang="scss">
  .q-btn.extra-btn-square {
    position: relative;
    background: $extra-btn-square-bg;
    font-family: $common-lighter-font-family;
    font-weight: normal;
    width: 140px;
    height: 140px;
    padding: 0;
    &:before {
      box-shadow: $btn-soft-shadow; // quasar override
    }

    &[active] {
      .q-btn__content:before {
        border: 2px solid currentColor; // quasar override
      }
    }

    .q-btn__content {
      flex-direction: column-reverse; // two lines
      padding: 5px;

      > i {
        font-size: 4em;
        margin-right: 0;
        margin-bottom: 0;
        margin-top: 15px;
      }

      > i + * {
        font-family: $common-lighter-font-family;
        color: $primary;
        display: flex !important;
        justify-content: center;
        flex-direction: column;
        height: 2em; // always prepare for 2 lines
        font-size: 1.25em;
        line-height: 1.15em;
      }

      > .extra-btn-square-badge {
        display: inline-block;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        box-shadow: $btn-shadow;
        position: absolute;
        z-index: 1;
        top: 10px;
        right: 10px;
        background-color: $secondary;
      }
    }

    &.extra-btn-square-inverted {
      .q-btn__content {
        flex-direction: column; // two lines reversed

        > i {
          margin-top: 0;
          margin-bottom: 15px;
        }
      }
    }
    .rounded-badge {
      top: 15px !important;
      right: 15px !important;
      border-radius: 50px !important;
    }
    .chip {
      position: absolute;
      top: -11px;
      right: 0px;
    }
  }
</style>
